
<div class="flex flex-row items-center pl-3 pr-3 pt-1 mb-2 border-box">
  <span class="text-md color-light leading-5">{{
    '#WORK_NOTE.DIALOGS.FINISH.INFO' | translate
  }}</span>
</div>

  @if(!quantitiesDone()) {
  <div
    class="flex flex-col soft-message-bar soft-message-bar-warning mr-3 ml-3"
    >
    <strong>Sicher, dass alles erledigt wurde?</strong>
    @if (signatureMissing()) {
      <span class="soft-text">Der Arbeitsschein wurde noch NICHT unterschrieben</span>
    }
    </div>
  }

  <form [formGroup]="form" class="flex flex-row items-center mt-2 mb-2 pl-3 pr-3 pt-1 border-box">
    <div class="flex flex-col w-full">
      <soft-input
        type="email"
        formControlName="email"
      ></soft-input>
      @if (!(form.controls['email'] | isValid)) {
        <soft-validation-container
          [validation]="form | validationMessage: 'email'"
          class="soft-property-validation"
        ></soft-validation-container>
      }
    </div>
  </form>

  <div class="flex flex-row flex-nowrap mt-3">
    <button class="soft-button secondary fill-force" (click)="cancel()">
      {{ '#WORK_NOTE.DIALOGS.FINISH.SAVE_BTN' | translate }}
    </button>
    <button class="soft-button primary fill-force" (click)="close()">
      {{ '#WORK_NOTE.DIALOGS.FINISH.SUBMIT_BTN' | translate }}
    </button>
  </div>
